import React from "react";
import { motion } from "framer-motion";
import styles from "./Footer.module.css";
import { Mail, Phone, MapPin, BadgeInfo, GraduationCap, Github, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Brand Section */}
                <motion.div 
                    className={styles.brand}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <div className={styles.brandHeader}>
                        <div className={styles.logoIcon}>
                            <GraduationCap size={32} />
                        </div>
                        <h2 className={styles.logo}>Z Student Portal</h2>
                    </div>
                    <p className={styles.tagline}>
                        A Student Effort for Students. Making campus life easier, one feature at a time.
                    </p>
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <Link to="/about" className={styles.aboutLink}>
                            <BadgeInfo size={16} />
                            <span>Learn More About Us</span>
                            <ExternalLink size={14} />
                        </Link>
                    </motion.div>
                </motion.div>

                {/* Contact Section */}
                <motion.div 
                    className={styles.contact}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    <h3 className={styles.contactTitle}>Get In Touch</h3>
                    <div className={styles.contactItems}>
                        <motion.a 
                            href="mailto:xeeshan303.3.2@gmail.com"
                            className={styles.contactItem}
                            whileHover={{ scale: 1.05, x: 5 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <div className={styles.contactIcon}>
                                <Mail size={18} />
                            </div>
                            <span>xeeshan303.3.2@gmail.com</span>
                        </motion.a>
                        <motion.a 
                            href="tel:+923109233844"
                            className={styles.contactItem}
                            whileHover={{ scale: 1.05, x: 5 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <div className={styles.contactIcon}>
                                <Phone size={18} />
                            </div>
                            <span>+92 310 9233844</span>
                        </motion.a>
                        <div className={styles.contactItem}>
                            <div className={styles.contactIcon}>
                                <MapPin size={18} />
                            </div>
                            <span>Lahore, Pakistan</span>
                        </div>
                    </div>
                </motion.div>
            </div>

            <div className={styles.divider}></div>

            <motion.div 
                className={styles.bottomBar}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <p className={styles.copyright}>
                    Designed & Developed by Zeeshan Sarfraz
                </p>
                <p className={styles.rights}>
                    © {new Date().getFullYear()} Z Student Portal. All rights reserved.
                </p>
            </motion.div>
        </footer>
    );
};

export default Footer;
